import { useLang } from 'hooks/lang';

import { FullProjectIssue } from 'entities';

import { Button } from 'components/Blocks';
import { CirclePlusIcon } from 'components/Icons';

import { CreateModal } from './CreateModal';

import { useProjectProfile } from '../context';
import { useToggleV2, useUser } from 'hooks';

import { verifyIfCanCreateIssue } from './utils';

interface Props {
  registerNewIssue: (newIssue: FullProjectIssue) => void;
}

export function CreateIssueButton({ registerNewIssue }: Props) {
  const { t } = useLang();
  const user = useUser();
  const { projectUsers, project } = useProjectProfile();

  const [open, openHandlers] = useToggleV2();

  const canCreate = verifyIfCanCreateIssue({ user, projectUsers, project });

  if (!canCreate) return null;

  return (
    <>
      <CreateModal open={open} close={openHandlers.turnOff} registerNewIssue={registerNewIssue} />

      <Button variant="ghost" onClick={openHandlers.turnOn}>
        <CirclePlusIcon />
        {t('register-issue')}
      </Button>
    </>
  );
}
